import { EProjectType } from "@kuika/kuika-cl-model";
import classNames from "classnames";
import React from "react";
import KuikaInfoBox from "../../../ui-kit/kuika-info-box/kuika-info-box";
import KuikaSvg from "../../../ui-kit/kuika-svg/kuika-svg";
import KuikaH5 from "../../../ui-kit/typography/H5/H5";
import KuikaSmallMediumText from "../../../ui-kit/typography/SmallMediumText/SmallMediumText";
import KuikaSmallText from "../../../ui-kit/typography/SmallText/SmallText";
import KuikaText from "../../../ui-kit/typography/Text/Text";
import "./project-definition-app-type.scss";

export interface IState {}

export interface IProps {
  projectType: EProjectType | undefined;
  changeProjectType: (type: EProjectType) => void;
  isEditing: boolean;
}

class ProjectDefinitionAppType extends React.PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {};
  }

  render() {
    const isWeb: boolean = this.props.projectType === EProjectType.Desktop;
    const isMobile: boolean = this.props.projectType === EProjectType.Mobile;
    const disabled: boolean = this.props.isEditing;
    const webDeviceColor: string = isWeb ? "var(--blue-5)" : "var(--dark-6)";
    const mobileDeviceColor: string = isMobile ? "var(--blue-5)" : "var(--dark-6)";
    return (
      <div className="kuika-app-type kuika-flex-column">
        <div className="kuika-app-type__section kuika-flex-column--gap-m">
          <div className="kuika-app-type__label">
            <KuikaSmallMediumText>CHOOSE APP TYPE</KuikaSmallMediumText>
          </div>

          <div className="kuika-app-type__cards kuika-flex--gap-l">
            <div
              data-testid="webApp"
              className={classNames("kuika-app-type__card", {
                "kuika-app-type__card--selected": isWeb,
                "kuika-app-type__card--disabled": disabled
              })}
              onClick={disabled ? undefined : () => this.props.changeProjectType(EProjectType.Desktop)}
            >
              <div className="kuika-app-type__card-head">
                <div className="kuika-app-type__card-icon">
                  <KuikaSvg
                    name="device-imac-thin"
                    width={38}
                    height={38}
                    color={webDeviceColor}
                    className="kuika-app-type__dev kuika-app-type__dev--imac"
                  />
                  <KuikaSvg
                    name="device-tablet-thin"
                    width={29}
                    height={29}
                    color={webDeviceColor}
                    className="kuika-app-type__dev kuika-app-type__dev--tablet-web"
                  />
                  <KuikaSvg
                    name="device-mobile-thin"
                    width={23}
                    height={23}
                    color={webDeviceColor}
                    className="kuika-app-type__dev kuika-app-type__dev--mobile-web"
                  />
                </div>
                {isWeb && (
                  <KuikaSvg
                    name="check"
                    width={20}
                    height={20}
                    color="var(--green-6)"
                    className="kuika-app-type__card-check"
                    data-testid="webAppSelected"
                  />
                )}
              </div>
              <div className="kuika-app-type__card-text kuika-flex-column--gap-s">
                <KuikaH5>Web App</KuikaH5>
                <KuikaText className="kuika-app-type__card-desc">
                  Responsive web application accessible from any browser
                </KuikaText>
              </div>
            </div>

            <div
              data-testid="mobileApp"
              className={classNames("kuika-app-type__card", {
                "kuika-app-type__card--selected": isMobile,
                "kuika-app-type__card--disabled": disabled
              })}
              onClick={disabled ? undefined : () => this.props.changeProjectType(EProjectType.Mobile)}
            >
              <div className="kuika-app-type__card-head">
                <div className="kuika-app-type__card-icon">
                  <KuikaSvg
                    name="device-tablet-thin"
                    width={45}
                    height={45}
                    color={mobileDeviceColor}
                    className="kuika-app-type__dev kuika-app-type__dev--tablet-mob"
                  />
                  <KuikaSvg
                    name="device-mobile-thin"
                    width={31}
                    height={31}
                    color={mobileDeviceColor}
                    className="kuika-app-type__dev kuika-app-type__dev--mobile-mob"
                  />
                </div>
                {isMobile && (
                  <KuikaSvg
                    name="check"
                    width={20}
                    height={20}
                    color="var(--green-6)"
                    className="kuika-app-type__card-check"
                    data-testid="mobileAppSelected"
                  />
                )}
              </div>
              <div className="kuika-app-type__card-text kuika-flex-column--gap-s">
                <KuikaH5>Mobile Compatible App</KuikaH5>
                <KuikaText className="kuika-app-type__card-desc">
                  Optimized for mobile and tablet devices with native feel
                </KuikaText>
              </div>
            </div>
          </div>

          {!disabled && (
            <div className="kuika-app-type__info">
              <KuikaInfoBox
                color="blue"
                leftUnit={
                  <div className="kuika-app-type__info-content kuika-flex--gap-xs kuika-align-center">
                    <KuikaSvg name="info-circle" width={16} height={16} />
                    <KuikaSmallText className="kuika-app-type__info-text">
                      The application type cannot be changed after the app is created.
                    </KuikaSmallText>
                  </div>
                }
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default ProjectDefinitionAppType;
